module.exports = __webpack_public_path__ + "images/Pak Budi.495975a6.png";